
import React from 'react';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Drawer from "@material-ui/core/Drawer";
import PlayerStatus from "./PlayerStatus";
import withWidth from "@material-ui/core/withWidth";
import Link from "@material-ui/core/Link";
import {getCurrentPoint} from "../util/player";
import {Timer, TrendingUp} from "@material-ui/icons";
import Badge from "@material-ui/core/Badge";
import Fab from "@material-ui/core/Fab";
import RaceMap from "./RaceMap";
import {IconButton} from "@material-ui/core";
import Button from "@material-ui/core/Button";

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}


function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}



const headCells = [
    { id: 'position', numeric: true, disablePadding: true, label: 'Loc' },
    { id: 'bib', numeric: true, disablePadding:  true, label: 'Nr' },
    { id: 'name', numeric: false, disablePadding: true, label: 'Nume' },
    { id: 'category_rank', numeric: true, disablePadding: true, label: 'Loc Categorie' },
    { id: 'checkpoint', numeric: true, disablePadding: true, label: 'Checkpoint' },
    { id: 'status', numeric: false, disablePadding: true, label: 'Stare' },
    { id: 'category', numeric: false, disablePadding: true, label: 'Categorie' },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy,  onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>

                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                  {order === 'desc' ? 'sortat descendent' : 'sortat ascendent'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}

            </TableRow>
        </TableHead>
    );
}


const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;
    return (

        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >

            {numSelected > 0 ? (
                <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
                    Ați selectat {numSelected} {(numSelected <= 1)? "concurent" : "concurenți"}
                </Typography>
            ) : (
                <Typography className={classes.title} variant="subtitle1" id="tableTitle" component="div">
                    Selectează concurenți
                </Typography>
            )}

        </Toolbar>
    );
};


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    floatingButtonRight:{
        position:'fixed',
        bottom:'4vh',
        right:'5vw',
        float:'bottom',
    },
    floatingButtonTop:{
        position:'fixed',
        bottom:'4vh',
        left:'5vw',
        float:'bottom',
    },
}));

function MaterialTable(props) {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('position');
    let [selected,setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [TabDirection, setTabDirection] = React.useState((props.width==='xs') ? 'left':'top')
    const [TableSpacing, setTableSpacing] = React.useState((props.width==='xs') ? 'checkbox':'default')
    const [open, setOpen] = React.useState(false);



    const handleClick = (event, bib) => {
            const selectedIndex = selected.indexOf(bib);
            let newSelected = [];
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, bib);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }
            if(selected.length<8 || selectedIndex !== -1)
                setSelected(newSelected);
    };

    const [state, setState] = React.useState({
        [TabDirection]: false,
        player: {}});

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        let otherDirection = 'left';
        if(TabDirection==='left')
            otherDirection = 'top';

        setState({ ...state, [otherDirection]:false, [TabDirection]: open })
    };

    const isSelected = (bib) => selected.indexOf(bib) !== -1;

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, props.race.length - page * rowsPerPage);

    const showIfLargeScreen = () =>{
        if(props.width ==='md'|| props.width === 'lg')
            return(
            <FormControlLabel
                control={<Switch checked={dense} onChange={handleChangeDense} />}
                label="Randuri Subtiri"
            />);
    }


    props.race.participants = props.race.participants.map((participant) => {
        return {...participant, checkpoint:parseInt(getCurrentPoint(participant).replace(/\D/g,''))}
    })
    return (
        <div className={classes.root}>
            <RaceMap
                open={open}
                handleClose={handleClose}
                race={props.race}
                select = {selected}>
            </RaceMap>
            <Drawer anchor={TabDirection} open={state[TabDirection]} onClose={toggleDrawer(false)}>
                <div  onClick={toggleDrawer(false)}  style={{width:'100%',height:'100%'}}
                     onKeyDown={toggleDrawer( false)}>
                        <PlayerStatus
                            checkpoints={props.race.checkpoints}
                            raceName={props.raceName}
                            race={props.race}
                            selected={selected}>
                        </PlayerStatus>
                </div>
            </Drawer>

            <Paper className={classes.paper}>
                <EnhancedTableToolbar numSelected={selected.length}  />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={props.race.participants.length}
                        />
                        <TableBody>
                            {stableSort(props.race.participants, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row.bib);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"

                                            onClick={(event) => handleClick(event, row.bib)}
                                            aria-disabled={isItemSelected}
                                            tabIndex={-1}
                                            selected={isItemSelected}
                                            key={row.name}
                                        >
                                            <TableCell  padding={TableSpacing} align="center">{row.position}</TableCell>
                                            <TableCell  padding={TableSpacing} align="center">{row.bib}</TableCell>
                                            <TableCell scope="row" padding={TableSpacing} component="th" id={labelId} >
                                                <Link href={"#"}>{row.name}</Link>
                                            </TableCell>
                                            <TableCell padding={TableSpacing} align="center">{row.category_rank}</TableCell>
                                            <TableCell  padding={TableSpacing} align="center" >
                                                P{row.checkpoint}

                                                <Typography color={"primary"}>
                                                    {row[getCurrentPoint(row)]}
                                                </Typography>

                                            </TableCell>
                                            <TableCell  padding={TableSpacing} align="center">{row.status}</TableCell>
                                            <TableCell   align="center">{row.category}</TableCell>
                                        </TableRow>

                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={props.race.participants.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />

            </Paper>

            {showIfLargeScreen()}
            <Fab variant="extended"
                 disabled={selected.length<1 || selected.length >7}
                 color={"secondary"}
                 className={classes.floatingButtonRight}
                 onClick = {handleOpen}
                 >

                <Badge badgeContent={selected.length} color="default">
                    <Typography  variant={"button"}>Traseu</Typography>
                    <TrendingUp/>

                </Badge>
            </Fab>
            <Fab
                variant={"extended"}
                 disabled={selected.length<1 || selected.length >4}
                 color={"primary"}
                 onClick={toggleDrawer(true)}
                 className={classes.floatingButtonTop}
                 >

                <Badge badgeContent={selected.length} color="default">
                    <Typography variant={"button"}>Timp</Typography>
                    <Timer/>
                </Badge>

            </Fab>
        </div>
    );
}


export default withWidth()(MaterialTable);
